import { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import {
  useCreate,
  useNotify,
  SimpleForm,
  Create,
  useResourceContext,
  useRefresh,
  FileInput,
  FileField,
  useTranslate,
  Button,
} from "react-admin";
import SaveDeleteBtns from "../../saveDeleteBtns/SaveDeleteBtn";
import UploadProgress from "../../uploadProgresses/UploadProgress";

export default function MotifUploadDialog({ open, setOpen }) {
  const [create, { isLoading: isCreateLoading }] = useCreate();
  const notify = useNotify();
  const refresh = useRefresh();
  const t = useTranslate();
  const resource = useResourceContext(); // cuman nama resource

  const save = useCallback(
    async (values) => {
      try {
        await create(
          resource + "/upload",
          { data: values },
          {
            returnPromise: true,
            onSuccess: (data) => {
              notify("ra.notification.created", {
                messageArgs: { smart_count: 1 },
              });
              setOpen(false);
              refresh();
            },
          }
        );
      } catch (error) {
        if (error.message) {
          notify(error.message, {
            type: "error",
          });
        }
      }
    },
    [create]
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} keepMounted={false}>
      <Create title={" "} sx={{ "& .RaCreate-main": { mt: 0 } }}>
        <SimpleForm
          warnWhenUnsavedChanges
          onSubmit={save}
          toolbar={<SaveDeleteBtns />}
          mode="onBlur"
          reValidateMode="onBlur"
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pt: 0,
            }}
          >
            <DialogTitle>{t("mine.label.upload")} Motifs</DialogTitle>
            <IconButton onClick={handleClose} sx={{ mr: "11px" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent>
            <Button
              component="a"
              href={process.env.REACT_APP_API_URL + "/template/T_SetupMotif.xlsx"}
              target="_blank"
              startIcon={<DownloadIcon />}
              label="Download Template"
              sx={{ mb: 3 }}
            />
            <FileInput
              source="file"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            >
              <FileField source="src" title="title" />
            </FileInput>
            <Typography variant="body2">
              Setelah export table motif dari database DB-ACURA, selanjutnya
              download template excelnya disini, buka template tersebut lalu
              ganti kolom A, B, C dengan data yang telah di export dari
              masing-masing depo. Jangan mengubah urutan kolom atau nama sheet
              template.
            </Typography>
          </DialogContent>
        </SimpleForm>
      </Create>
      <UploadProgress isCreateLoading={isCreateLoading} />
    </Dialog>
  );
}
